import { useState, useEffect, useMemo } from 'react';
import { apiService, TenantData } from '../services/api';

export function useTenantConfig(tenantSlug: string = 'default') {
  const [tenantData, setTenantData] = useState<TenantData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function loadTenantData() {
      try {
        setLoading(true);
        const data = await apiService.getTenantBySlug(tenantSlug);
        setTenantData(data);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load tenant configuration');
      } finally {
        setLoading(false);
      }
    }

    loadTenantData();
  }, [tenantSlug]);

  return useMemo(() => ({ tenantData, loading, error }), [tenantData, loading, error]);
}

